export const GET_VEHICALTYREPOSITION_REQUEST = 'GET_VEHICALTYREPOSITION_REQUEST';
export const GET_VEHICALTYREPOSITION_SUCCESS = 'GET_VEHICALTYREPOSITION_SUCCESS';
export const GET_VEHICALTYREPOSITION_FAIL = 'GET_VEHICALTYREPOSITION_FAIL';

export const GET_MAPPED_VEHICALTYREPOSITION_REQUEST = 'GET_MAPPED_VEHICALTYREPOSITION_REQUEST';
export const GET_MAPPED_VEHICALTYREPOSITION_SUCCESS = 'GET_MAPPED_VEHICALTYREPOSITION_SUCCESS';
export const GET_MAPPED_VEHICALTYREPOSITION_FAIL = 'GET_MAPPED_VEHICALTYREPOSITION_FAIL';

export const UPDATE_VEHICALTYREPOSITION_REQUEST = 'UPDATE_VEHICALTYREPOSITION_REQUEST';
export const UPDATE_VEHICALTYREPOSITION_SUCCESS = 'UPDATE_VEHICALTYREPOSITION_SUCCESS';
export const UPDATE_VEHICALTYREPOSITION_FAIL = 'UPDATE_VEHICALTYREPOSITION_FAIL';

export const CREATE_VEHICLETYPE_REQUEST = 'CREATE_VEHICLETYPE_REQUEST';
export const CREATE_VEHICLETYPE_SUCCESS = 'CREATE_VEHICLETYPE_SUCCESS';
export const CREATE_VEHICLETYPE_FAIL = 'CREATE_VEHICLETYPE_FAIL';

export const UPDATE_VEHICLETYPE_REQUEST = 'UPDATE_VEHICLETYPE_REQUEST';
export const UPDATE_VEHICLETYPE_SUCCESS = 'UPDATE_VEHICLETYPE_SUCCESS';
export const UPDATE_VEHICLETYPE_FAIL = 'UPDATE_VEHICLETYPE_FAIL';

export const GET_VEHICLETYPE_REQUEST = 'GET_VEHICLETYPE_REQUEST';
export const GET_VEHICLETYPE_SUCCESS = 'GET_VEHICLETYPE_SUCCESS';
export const GET_VEHICLETYPE_FAIL = 'GET_VEHICLETYPE_FAIL';
